import { Controller } from "@hotwired/stimulus"

// Selectize-based supplier typeahead allowing any number of suppliers to be
// selected. Preselected suppliers are read from the element's
// `data-selectize-value` attribute (JSON) and results are loaded from the
// public suppliers API, matching the legacy `$.uf.initializeSupplierTypeahead`
// behaviour but with no item cap.
export default class extends Controller {
  connect() {
    $(this.element).selectize({
      plugins: ['remove_button'],
      valueField: 'id',
      labelField: 'name',
      searchField: ['name'],
      create: false,
      closeAfterSelect: true,
      maxItems: null,
      render: {
        option: (item, escape) => {
          return `<div><span class="title"><strong>${escape(item.name)}</strong></span></div>`
        }
      },
      load: (query, callback) => {
        $.ajax({
          url: `/api/v1/suppliers?q=${encodeURIComponent(query)}`,
          type: 'GET',
          error: () => callback(),
          success: (res) => callback(res.suppliers.slice(0, 10))
        })
      },
      onInitialize: function () {
        const raw = this.$input.attr('data-selectize-value')
        if (!raw || raw.length === 0) return

        const preselected = JSON.parse(raw)
        const options = Array.isArray(preselected) ? preselected : [preselected]
        options.forEach((option) => {
          this.addOption(option)
          this.addItem(option[this.settings.valueField])
        })
      }
    })
  }

  disconnect() {
    if (this.element.selectize) {
      this.element.selectize.destroy()
    }
  }
}
